import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const ASSET_BASE = `${process.env.PUBLIC_URL || ""}/assets`;

const POSTS = [
  {
    id: "insight-continuous-assurance",
    tag: "PDPL",
    title: "How the 45-day rule changes your customer service pipeline",
    date: "Feb 2026",
    image: {
      base: "insight-continuous-assurance",
      alt: "Diagram comparing an old customer-service pipeline of unlimited follow-ups, stalling cases and low satisfaction against a new 45-day-rule pipeline of faster processing, clearer tracking, prompt resolutions and higher satisfaction",
    },
  },
  {
    id: "insight-verified-closure",
    tag: "AI",
    title: "The three things AI does well in Omani logistics — and one it doesn't",
    date: "Jan 2026",
    image: {
      base: "insight-verified-closure",
      fallback: "jpg",
      alt: "Split infographic titled 'AI in Omani Logistics' comparing where AI does well — fraud detection, transaction logistics, predictive analytics, document automation — against where AI struggles: complex negotiation, emotional intelligence, ethical judgment and creative problem-solving.",
    },
  },
  {
    id: "insight-multi-client-practice",
    tag: "Engineering",
    title: "Fixed-price sprints without hidden compromises",
    date: "Jan 2026",
    image: {
      base: "insight-multi-client-practice",
      alt: "Diagram of a fixed-price sprint showing the plan, execute and deliver phases with predictability and risk-mitigation callouts and 'no hidden compromises' shield",
    },
  },
  {
    id: "insight-boardready-risk-register",
    tag: "Meyar",
    title: "Building a risk register your board will actually read",
    date: "Dec 2025",
    image: {
      base: "insight-boardready-risk-register",
      alt: "Illustration of board members reviewing a simplified risk register with prioritised high-impact risks, dollar-value quantification, simple visual charts and highlighted mitigation actions",
    },
  },
];

export function Insights() {
  return (
    <section data-testid="insights-section" className="bg-wafa-cream/40">
      <div className="mx-auto max-w-7xl px-4 py-20 lg:px-6 lg:py-28">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-3xl">
            <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">Insights</div>
            <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl">
              Notes from our engineers.
            </h2>
          </div>
          <Link to="/blog" data-testid="insights-view-all" className="inline-flex items-center gap-1 text-sm font-semibold text-wafa-deep underline-offset-4 hover:underline">
            View all posts <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {POSTS.map((p) => (
            <Link
              key={p.id}
              to="/blog"
              data-testid={`insight-card-${p.id}`}
              className="group flex flex-col rounded-lg border border-wafa-deep/10 bg-white p-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(14,79,58,0.2)]"
            >
              <picture>
                <source
                  type="image/webp"
                  srcSet={`${ASSET_BASE}/${p.image.base}-640.webp`}
                />
                <img
                  src={`${ASSET_BASE}/${p.image.base}.${p.image.fallback || 'png'}`}
                  alt={p.image.alt}
                  width="640"
                  height="400"
                  loading="lazy"
                  decoding="async"
                  data-testid={`insight-card-image-${p.id}`}
                  className="block aspect-[8/5] w-full rounded-md object-cover"
                />
              </picture>
              <div className="p-3">
                <div className="inline-flex items-center gap-2 text-[10px] font-semibold uppercase tracking-wider text-wafa-primary">
                  <span>{p.tag}</span>
                  <span className="text-wafa-ink/40">·</span>
                  <span className="text-wafa-ink/50">{p.date}</span>
                </div>
                <div className="mt-2 font-heading text-base font-semibold text-wafa-deep group-hover:text-wafa-primary">
                  {p.title}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
